module.exports = __webpack_public_path__ + "static/media/imgIntro.78dbc77a.png";